/**
 *
 */
export const getImage = (club, size = 'wide') => {
    if (!club) {
        switch (size) {
            case 'super_wide': return '/img/club-defaults/super-wide.jpg';
            case 'tall':       return '/img/club-defaults/tall.jpg';
            default:           return '/img/club-defaults/wide.jpg';
        }
    }
    switch (size) {
        case 'super_wide':
            return club.super_wide_image ?? '/img/club-defaults/super-wide.jpg';
        case 'wide':
            return club.wide_image ?? '/img/club-defaults/wide.jpg';
        case 'tall':
            return club.tall_image ?? '/img/club-defaults/tall.jpg';
        default:
            return club.wide_image ?? '/img/club-defaults/wide.jpg';
    }
}

export const isFutureDate = (date) => {
    return new Date(date) > new Date();
};